import gql from 'graphql-tag';

const GC_GET_USER_N_ORGAS = gql`
query GetUserInfo ($id:uuid!){
    users(where: {id: {_eq: $id}}) {
        id
        email
        first_name
        name
        role
        userOrganisations {
            organisations {
                name
                id
            }
        }
        promotion_users(distinct_on: promotion_id) {
            promotion {
                title
                id
                start_date
                end_date
            }
        }
    }
    organisations_aggregate(distinct_on: id) {
        nodes {
            name
            id
        }
    }
}
`


const GC_EDIT_USER = gql`
mutation UpdateUser($id:uuid!, $email:String!, $fName:String!, $lName:String!, $orgas: [user_organisations_insert_input!]!) {
    update_users_by_pk(pk_columns: {id: $id}, _set: {
        email: $email,
        first_name: $fName,
        name: $lName,
        role: $role
    }) {
      id
    }
    delete_user_organisations(where: {user: {_eq: $id}}) {
        affected_rows
    }
    insert_user_organisations(objects: $orgas) {
        affected_rows
    }
  }
`

const GC_EDIT_USER_AND_PASSWORD = gql`
mutation UpdateUser($id:uuid!, $email:String!, $company: String, $seniority: Int, $status: Int, $role: String, $fName:String!, $lName:String!, $password:String!, $orgas: [user_organisations_insert_input!]!) {
    update_users_by_pk(pk_columns: {id: $id}, _set: {
        email: $email,
        first_name: $fName,
        name: $lName,
        role: $role
        password: $password
    }) {
      id
    }
    delete_user_organisations(where: {user: {_eq: $id}}) {
        affected_rows
    }
    insert_user_organisations(objects: $orgas) {
        affected_rows
    }
  }
`

const GC_ADD_USER_ONE = gql`
    mutation AddUser($email:String!, $company: String, $status: Int, $seniority: Int, $role: String, $fName:String!, $lName:String, $password:String, $orgas: [user_organisations_insert_input!]!) {
        insert_users_one(
            object: {
                email: $email,
                first_name: $fName,
                name: $lName,
                role: $role,
                password: $password,
                userOrganisations: {
                    data: $orgas
                }
            }
        ){
            id
        }
    }
`

const GC_EDIT_ORGA_ONE = gql`
mutation UpdateOrga($id: uuid!, $orga:organisations_set_input!) {
    update_organisations_by_pk(pk_columns: {id: $id}, _set: $orga) {
      id
    }
  }
`

const GC_ADD_ORGA_ONE = gql`
mutation AddOrga($orga:organisations_insert_input!) {
    insert_organisations_one(object: $orga) {
      id
    }
  }
`

const GC_GET_ORGA_ONE = gql`
query GetOrga($id: uuid!) {
    organisations_by_pk(id: $id) {
      name
      id
      city
      address2
      address
      post_code
      country
      admin_id
      federation_id
      housing
      hlm
      admin{
          id
          name
      }
      userOrganisations(distinct_on: user) {
        user
      }
    }
  }
`

export {
    GC_GET_USER_N_ORGAS,
    GC_EDIT_USER,
    GC_EDIT_USER_AND_PASSWORD,
    GC_EDIT_ORGA_ONE,
    GC_GET_ORGA_ONE,
    GC_ADD_USER_ONE,
    GC_ADD_ORGA_ONE
}